import React from 'react';
import PropTypes from 'prop-types';

import { mountTarget, unmountTarget } from '../../mountable';
import { DetailedImage } from '../../accessibility/DetailedImage/component';

class ImageAttachment extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
    altText: PropTypes.string,
    description: PropTypes.string,
    citationText: PropTypes.string,
    citationLink: PropTypes.string,
  };

  static defaultProps = {
    className: null,
    altText: '',
    description: null,
    citationText: null,
    citationLink: null,
  };

  render() {
    const {
      className,
      src,
      altText,
      description,
      citationText,
      citationLink,
    } = this.props;

    const showDetailedImage = !!description || !!citationText || !!citationLink;

    if (!showDetailedImage) {
      return <img className={className} src={src} alt={altText} />;
    }

    return (
      <DetailedImage
        imageClassName={className}
        src={src}
        altText={altText}
        longDescription={description}
        citationText={citationText}
        citationLink={citationLink}
      />
    );
  }
}

// export these as helpers to legacy code
export const mount = (target, props) =>
  mountTarget(ImageAttachment, target, props);
export const unmount = unmountTarget;
